import styled from 'styled-components';
import { media } from '../breakpoints';

const GUTTER_PX = 24;

export const Grid = styled.div`
	display: grid;
	column-gap: ${GUTTER_PX}px;
	row-gap: ${GUTTER_PX}px;
	grid-template-columns: repeat(4, minmax(0, 1fr));

	${media.tablet} {
		grid-template-columns: repeat(8, minmax(0, 1fr));
	}

	${media.desktop} {
		grid-template-columns: repeat(12, minmax(0, 1fr));
	}
`;
